// Module
var code = `<div class="{{spinnerCtrl.showFullScreen!==false ? 'tft-spinner' : 'tft-spinner-inline'}}"> <div class="ng-loader"> <svg class="ld-circular" viewBox="25 25 50 50"> <circle class="ld-path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/> </svg> </div> </div>`;
// Exports
export default code;